import styles from "./Badge.module.css"

export default function Badge({image, isActive}) 
{
    return (<div className={styles.Main + (isActive ? " " + styles.active: "")}>
        <img src={image} alt="badgeIcon"/>
    </div>)
}